import { createContext, useContext, ReactNode } from 'react'
import { useSession } from './use-session'

type SessionContextValue = ReturnType<typeof useSession>

const SessionContext = createContext<SessionContextValue | null>(null)

export function SessionProvider({ children }: { children: ReactNode }) {
	const session = useSession()
	return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>
}

export function useSessionContext(): SessionContextValue {
	const ctx = useContext(SessionContext)
	if (!ctx)
		throw new Error('useSessionContext must be used within SessionProvider')
	return ctx
}
